<template>
    <component :is="tag" class="actions" v-if="canDetail || canEdit || canDelete || hasDefaultSlot">
        <template v-if="hasActions">
            <div class="dropdown">
                <button
                    class="btn btn-main dropdown-toggle m-0"
                    type="button"
                    id="dropdownMenuColumnActions"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    {{ $t(`${dropdownTitle}`) }}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuColumnActions">
                    <template v-for="(action, aIndex) in filteredActions">
                        <div class="dropdown-divider" v-if="action.divider == 'before'"></div>
                        <a
                            :key="`column-action-${index}-${aIndex}`"
                            class="dropdown-item d-flex align-items-center text-left text-sm w-100"
                            href="#"
                            @click.prevent="action.fn ? action.fn(action.id, row, fnSearch) : () => {return false;}">
                            <i
                                v-if="action.icon"
                                :class="action.icon">
                            </i>
                            <span class="ml-2">{{ $t(action.text) }}</span>
                        </a>
                        <div class="dropdown-divider" v-if="action.divider == 'after'"></div>
                    </template>
                </div>
            </div>
        </template>
        <template v-else>
            <ul :class="listClass" class="list-group list-group-horizontal list-unstyled justify-content-end">
                <slot :confirm="confirm" :formatMsg="formatMsg"></slot>
                <li class="list-group-item" v-if="routeEdit && (canDetail || canEdit)">
                    <router-link :to="{ name: routeEdit, params: { id: row[keyProperty] }, query: routeEditQuery  }">
                        <i
                            class="fas action"
                            :title="translatedEditTitle"
                            :class="[canEdit ? 'fa-pencil-alt edit' : 'fa-eye view']"></i>
                    </router-link>
                </li>
                <li class="list-group-item" v-if="canDelete">
                    <i
                        class="far fa-trash-alt action delete"
                        :title="translatedDeleteTitle"
                        @click="confirm(deleteItem, row[keyProperty], index, formatMsg(deleteMsgTemplate))"></i>
                </li>
            </ul>
        </template>
    </component>
</template>

<script>
    export default {
        name: 'ColumnActions',
        components: {
        },
        props: {
            tag: {
                type: String,
                default: 'td',
            },
            keyProperty: {
                type: String,
                default: 'id',
            },
            index: {
                type: Number,
                required: true,
            },
            row: {
                type: Object,
                required: true,
            },
            routeEdit: {
                type: String,
                required: false,
            },
            routeEditQuery: {
                type: Object,
                default: () => {},
            },
            canDetail: {
                type: Boolean,
                default: false,
            },
            canAdd: {
                type: Boolean,
                default: false,
            },
            canEdit: {
                type: Boolean,
                default: false,
            },
            editTitle: {
                type: String,
                required: false,
                default: 'global.edit'
            },
            canDelete: {
                type: Boolean,
                default: false,
            },
            deleteTitle: {
                type: String,
                required: false,
                default: 'global.remove'
            },
            deleteMsgTemplate: {
                type: String,
                required: false,
                default: 'global.msg.confirm.delete-item'
            },
            label: {
                type: String,
                required: false,
                default: 'name'
            },
            listClass: {
                type: String,
                required: false,
                default: ''
            },
            fnSearch: {
                type: Function,
                default: null,
            },
            callbackDelete: {
                type: Function,
                default: null,
            },
            dropdownTitle: {
                type: String,
                required: false,
                default: 'global.actions'
            },
            actions: {
                type: Array,
                default: () => {return []},
            },
        },
        data() {
            return {

            }
        },
        mounted() {
            this.$nextTick(function () {
                this.$root.$helper.global.activeTooltip();
            })
        },
        computed: {
            filteredActions() {
                return (this.actions ?? []).filter(a => a.status || a.status == undefined);
            },
            hasActions() {
                return this.filteredActions && this.filteredActions.length>0;
            },
            hasDefaultSlot() {
                return !!this.$slots[ 'default' ] || !!this.$scopedSlots[ 'default' ];
            },
            translatedEditTitle() {
                return this.$t(this.editTitle);
            },
            translatedDeleteTitle() {
                return this.$t(this.deleteTitle);
            }
        },
        methods: {
            confirm(callback, id, idx, msg, fn) {
                this.$root.$emit('openConfirmation', {
                    id: id,
                    data: {index: idx},
                    text: msg,
                    callback: callback
                });
            },
            deleteItem(id, data) {
                this.$emit('delete', id, data, this.callbackDelete);
            },
            formatMsg(template) {
                return this.$t(template, {name: this.row && this.row.hasOwnProperty(this.label) ? this.row[this.label] : ''});
            },
        }
    }
</script>